import { render, staticRenderFns } from "./HistoryRegister.vue?vue&type=template&id=a3a67162&scoped=true&"
import script from "./HistoryRegister.vue?vue&type=script&lang=js&"
export * from "./HistoryRegister.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRegister.vue?vue&type=style&index=0&id=a3a67162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a67162",
  null
  
)

export default component.exports